import { Blocs } from '@business/blocs';
import { OrgId } from '@business/entities/organization';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';

export class DealPresentationsBloc extends BaseBloc {
  private readonly fileBloc = resolve(Blocs.file);

  constructor(private readonly orgId: OrgId) {
    super();
  }

  loading = new LoadingState();

  readonly items$ = this.fileBloc.items$;
  readonly breadcrumb$ = this.fileBloc.breadcrumb$;

  getItems = this.fileBloc.getItems;
  deleteFile = this.fileBloc.deleteFile;
}
